import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { RouterProvider } from "react-router-dom";
import {
  modifiedSellerRoutes,
  modifiedUnCompletedRoutes,
  modifiedBuyerRoutes,
} from "./routes";
import { useDispatch } from "react-redux";
import { getMyOrganization, getUserProfile } from "../redux/action/auth";
import SpinnersLoading from "../pages/loader/SpinnersLoading";
import { registerSW, subscribe } from "../helpers/serviceWorkerHelper";

export const AuthenticatedUser = () => {
  const shouldCallRegisterAndSubscribe = localStorage.getItem(
    "callRegisterAndSubscribe"
  );
  const { loading, accountType, accountSetUp } =
    useSelector((state) => state.account);

  const [getProfileLoading, setGetProfileLoading] = useState(true);
  const dispatch = useDispatch();

  if (shouldCallRegisterAndSubscribe) {
    registerSW().then((reg) => subscribe(reg));
  }

  useEffect(() => {
    dispatch(getUserProfile());
    dispatch(getMyOrganization());
  }, [dispatch]);


  useEffect(() => {
    if (!loading) {
      setTimeout(() => {
        setGetProfileLoading(false);
      }, 1000);
    }
  }, [loading]);

  if (loading || getProfileLoading) {
    return (
      <div className="mt-3">
        <SpinnersLoading />
      </div>
    );
  }

  return (
    <RouterProvider
      router={
        accountType === "industry" && accountSetUp
          ? modifiedSellerRoutes
          : accountType === "trader/aggregator" && accountSetUp
            ? modifiedBuyerRoutes
            : modifiedUnCompletedRoutes
      }
    />
  );
};

// accountSetUp && accountType === "industy"
//           ? modifiedSellerRoutes
//           : accountSetUp && accountType === "trader/aggregator"
//           ? modifiedBuyerRoutes
//           : modifiedUnCompletedRoutes

// accountSetUp && accountType === "industry"
// ? modifiedSellerRoutes
// : accountSetUp && accountType === "buyer"
// ? modifiedBuyerRoutes
// : !accountSetUp && modifiedUnCompletedRoutes
